export const demos = {
  boda: {
    key: "boda",
    label: "Boda",
    mode: "mixta",
    modeLabel: "Modalidad mixta",
    title: "Sofía & Mateo",
    subtitle: "Nuestra boda",
    dateLabel: "Sábado 14 de noviembre de 2026 · 19:00 h",
    dateISO: "2026-11-14T19:00:00-03:00",
    locationName: "Salón Los Lapachos · Asunción",
    mapsQuery: "Salón de eventos Asunción Paraguay",
    cover:
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=900&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=900&q=80",
    ],
    musicLabel: "Nuestra canción · Spotify",
    videoTitle: "Nuestro video · YouTube",
    itinerary: [
      { time: "19:00", title: "Ceremonia" },
      { time: "20:30", title: "Recepción y brindis" },
      { time: "21:30", title: "Cena" },
      { time: "23:00", title: "Fiesta" },
    ],
    guests: [
      { name: "Familia Benítez Rojas", phone: "0981555123", passes: 4, mesa: "Mesa 3" },
      { name: "Carla Duarte", phone: "0971222444", passes: 2, mesa: "Mesa 5" },
      { name: "Luis y Ana Marecos", phone: "0981333777", passes: 2, mesa: "Mesa 1" },
    ],
    demoPhone: "0981 555 123",
  },
  quince: {
    key: "quince",
    label: "Quinceaños",
    mode: "publica",
    modeLabel: "Modalidad pública",
    title: "Mis 15 · Valentina",
    subtitle: "Una noche para soñar",
    dateLabel: "Sábado 19 de setiembre de 2026 · 20:00 h",
    dateISO: "2026-09-19T20:00:00-04:00",
    locationName: "Club Centenario · San Lorenzo",
    mapsQuery: "Club Centenario San Lorenzo Paraguay",
    cover:
      "https://images.pexels.com/photos/15156701/pexels-photo-15156701.jpeg?auto=compress&cs=tinysrgb&w=900",
    gallery: [
      "https://images.pexels.com/photos/15156701/pexels-photo-15156701.jpeg?auto=compress&cs=tinysrgb&w=900",
      "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1496843916299-590492c751f4?auto=format&fit=crop&w=900&q=80",
    ],
    musicLabel: "Vals y playlist · MP3",
    videoTitle: "Video de mis 15 · YouTube",
    itinerary: [
      { time: "20:00", title: "Recepción" },
      { time: "21:00", title: "Vals principal" },
      { time: "22:00", title: "Cena" },
      { time: "23:30", title: "Baile y sorpresa" },
    ],
    guests: [
      { name: "Familia González Vera", phone: "0981444222", passes: 5, mesa: "Mesa 2" },
      { name: "Martina Ríos", phone: "0971888999", passes: 1, mesa: "Mesa 7" },
    ],
    demoPhone: "0981 444 222",
  },
  empresarial: {
    key: "empresarial",
    label: "Evento empresarial",
    mode: "privada",
    modeLabel: "Modalidad privada",
    title: "Gala Anual 2026",
    subtitle: "Cena de fin de año · Equipo Pro360",
    dateLabel: "Viernes 11 de diciembre de 2026 · 20:30 h",
    dateISO: "2026-12-11T20:30:00-03:00",
    locationName: "Centro de Convenciones · Asunción",
    mapsQuery: "Centro de Convenciones Asunción Paraguay",
    cover:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=900&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=900&q=80",
    ],
    musicLabel: "Música ambiental · Spotify",
    videoTitle: "Resumen del año · YouTube",
    itinerary: [
      { time: "20:30", title: "Acreditación y cóctel" },
      { time: "21:15", title: "Palabras de apertura" },
      { time: "21:45", title: "Cena" },
      { time: "23:00", title: "Premiación y brindis" },
    ],
    guests: [
      { name: "Diego Ayala · Operaciones", phone: "0981777666", passes: 2, mesa: "Mesa 4" },
      { name: "Laura Fernández · RRHH", phone: "0971000111", passes: 1, mesa: "Mesa 1" },
    ],
    demoPhone: "0981 777 666",
  },
};

export const demoList = [demos.boda, demos.quince, demos.empresarial];
